const MODEL_VIEWER_CSS =
  'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';

const injectModelViewerStyles = () => {
  if (document.querySelector('link[data-model-viewer-ui]')) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = MODEL_VIEWER_CSS;
  link.dataset.modelViewerUi = '';
  document.head.appendChild(link);
};

const setupModelViewerUI = (errors) => {
  if (errors || !window.Shopify?.ModelViewerUI) return;

  document.querySelectorAll('model-viewer').forEach((el) => {
    if (el.dataset.modelViewerReady) return;
    // Closed <dialog> lays out as 0×0 — wait until open before attaching UI
    const dialog = el.closest('dialog');
    if (dialog && !dialog.open) return;
    el.dataset.modelViewerReady = 'true';
    new window.Shopify.ModelViewerUI(el);
  });
};

export const setupProductModels = () => {
  if (!window.Shopify?.ModelViewerUI) return;
  setupModelViewerUI();
};

const setupShopifyXR = () => {
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', setupShopifyXR, {
      once: true,
    });
    return;
  }

  document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
    window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
    modelJSON.remove();
  });
  window.ShopifyXR.setupXRElements();
};

const initProductModel = () => {
  if (!document.querySelector('model-viewer')) return;
  if (!window.Shopify?.loadFeatures) return;

  injectModelViewerStyles();

  window.Shopify.loadFeatures([
    {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUI,
    },
  ]);

  window.Shopify.loadFeatures([
    {
      name: 'shopify-xr',
      version: '1.0',
      onLoad: (errors) => {
        if (errors) return;
        setupShopifyXR();
      },
    },
  ]);
};

export default initProductModel;
